export const texts = {
  navAria: "sidebar",
  searchAria: "Buscar",
  searchPlaceholder: "Buscar",
  searchClear: "Borrar búsqueda",
  hideSidebar: "Ocultar menú lateral",
  showSidebar: "Mostrar menú lateral",
  sections: {
    play: "Jugar",
    rewards: "Recompensas",
    account: "Cuenta",
    help: "Ayuda"
  },
  rows: {
    sports: "Deportes",
    casino: "Casino",
    tournaments: "Torneos",
    vip: "Programa VIP",
    promotions: "Bonos y promociones",
    referrals: "Referidos",
    profile: "Mi perfil",
    withdrawals: "Retiros",
    history: "Historial",
    assistant: "Asistente IA",
    faq: "Ayuda / FAQ",
    responsible: "Juego responsable"
  },
  badges: {
    pronto: "PRONTO",
    ganaL100: "GANA L100",
    verifica13: "VERIFICA 1/3",
    live247: "24/7"
  }
} as const
